import Vue from 'vue';
import Gravatar from 'vue-gravatar';

Vue.component('VGravatar', Gravatar);
